import React from 'react';

export const MoatownStorySection: React.FC = () => {
  const handleVideoPlay = () => {
    // 트래킹 이벤트
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'video_play_moatown_story', {
        video_id: 'kVfMuHZYhV8',
        section: '서울을 새롭게 모아타운 이야기'
      });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            서울을 새롭게 모아타운 이야기
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            대청마을 북측구역의 새로운 변화와 발전 방향을 소개합니다
          </p>
        </div>

        {/* YouTube 동영상 */}
        <div className="max-w-4xl mx-auto mb-8">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden" style={{ marginTop: '24px', marginBottom: '32px' }}>
            <div className="relative" style={{ paddingBottom: '56.25%' }}>
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/kVfMuHZYhV8?modestbranding=1&rel=0&controls=1&playsinline=1"
                title="서울을 새롭게 모아타운 이야기"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                onLoad={handleVideoPlay}
              ></iframe>
            </div>
          </div>
          
          {/* 대체 링크 */}
          <div className="text-center">
            <a 
              href="https://youtu.be/kVfMuHZYhV8" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline text-sm"
            >
              유튜브에서 열기
            </a>
          </div>
        </div>

        {/* 추가 콘텐츠 영역 */}
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">모아타운의 비전</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                    <i className="ri-lightbulb-line text-blue-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">혁신적 도시 모델</p>
                    <p className="text-gray-600">서울의 새로운 주거 기준을 제시하는 모아타운</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                    <i className="ri-group-line text-green-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">공동체 중심 개발</p>
                    <p className="text-gray-600">주민 참여와 소통을 바탕으로 한 지속가능한 발전</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                    <i className="ri-earth-line text-green-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">친환경 스마트 시티</p>
                    <p className="text-gray-600">미래 지향적 기술과 자연이 조화된 생활 공간</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">핵심 가치</h3>
              <div className="space-y-4">
                <div className="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-400">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-shield-check-line text-blue-600"></i>
                    </div>
                    <p className="font-semibold text-gray-900">투명성</p>
                  </div>
                  <p className="text-sm text-gray-600">모든 과정을 투명하게 공개하고 주민과 소통합니다</p>
                </div>
                
                <div className="bg-green-50 rounded-lg p-4 border-l-4 border-green-400">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-hand-heart-line text-green-600"></i>
                    </div>
                    <p className="font-semibold text-gray-900">상생</p>
                  </div>
                  <p className="text-sm text-gray-600">모든 이해관계자가 함께 발전하는 상생의 모델</p>
                </div>
                
                <div className="bg-purple-50 rounded-lg p-4 border-l-4 border-purple-400">
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-rocket-line text-purple-600"></i>
                    </div>
                    <p className="font-semibold text-gray-900">혁신</p>
                  </div>
                  <p className="text-sm text-gray-600">새로운 기술과 아이디어로 미래를 선도합니다</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};